import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { InscripcionConvenioRoutingModule } from './inscripcion-convenio-routing.module';
import { InscripcionConvenioComponent } from './inscripcion-convenio.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [InscripcionConvenioComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InscripcionConvenioRoutingModule,
    PipesModule,
    FormsModule,
    MatIconModule
  ]
})
export class InscripcionConvenioModule { }
